import React from "react";
import { useAuth } from "app/contexts/AuthContext";
import Forbidden from "app/containers/Forbidden";

const AdminRoute = ({ children }) => {
  const { user } = useAuth();

  return user?.isAdmin ? children : <Forbidden />;
};

export default AdminRoute;
